/* External dependencies */
import { concat, from, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { Warehouse } from '../../types';
import { listWarehouses } from '../../list-warehouses/redux/action';
import { createWarehouseError, createWarehouseSuccess } from './action';
import { createWarehouseMutation } from './mutation';
import { CreateWarehouseActionTypes, CreateWarehouseInput, CreateWarehouseRequest } from './types';

export default function createWarehouseEpic(action$, state$) {
  return action$.pipe(
    filter((action: CreateWarehouseRequest) => action.type === CreateWarehouseActionTypes.CREATE_WAREHOUSE),
    switchMap((action: CreateWarehouseRequest) =>
      from(createWarehouse(action.input)).pipe(
        switchMap((warehouse) => {
          const currentState = state$.value;
          const { statuses } = currentState.listWarehouses;

          return concat(from([createWarehouseSuccess(warehouse)]), from([listWarehouses({ filter: { statuses } })]));
        }),
        catchError((error) => of(createWarehouseError(error))),
      ),
    ),
  );
}

export async function createWarehouse(input: CreateWarehouseInput): Promise<Warehouse> {
  const graphQLClient = await getClient();

  const {
    data: { createWarehouse },
  } = await graphQLClient.mutate({
    mutation: createWarehouseMutation,
    variables: { input },
  });

  return createWarehouse;
}
